import axios from 'axios'

const url = process.env.REACT_APP_API_URL_TRANSACTION

const authConfig = () => ({
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
})

export default class NotificationService {
    list(unreadOnly = false, page = 0, size = 10) {
        return axios.get(`${url}/api/notifications`, {
            ...authConfig(),
            params: { unreadOnly, page, size, sort: 'createdAt,desc' }
        })
    }

    unreadCount(type = null) {
        const params = type ? { type } : undefined
        return axios.get(`${url}/api/notifications/unread-count`, {
            ...authConfig(),
            ...(params ? { params } : {})
        })
    }

    markRead(id) {
        return axios.post(`${url}/api/notifications/${id}/read`, {}, authConfig())
    }

    getDocument(documentId) {
        return axios.get(`${url}/get-smkhp-file/${documentId}`, authConfig())
    }
}

